const UserSearchIcon = ({ width = '17', height = '17', fill = '#E4F8ED' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="list/person_search">
        <mask
          id="mask0_8324_8790"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="17"
        >
          <rect
            id="Bounding box"
            x="0.724609"
            y="0.626953"
            width="16"
            height="16"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_8324_8790)">
          <path
            id="icon"
            d="M8.05794 8.62691C7.32461 8.62691 6.69683 8.3658 6.17461 7.84358C5.65239 7.32136 5.39128 6.69358 5.39128 5.96025C5.39128 5.22691 5.65239 4.59913 6.17461 4.07691C6.69683 3.55469 7.32461 3.29358 8.05794 3.29358C8.79128 3.29358 9.41905 3.55469 9.94128 4.07691C10.4635 4.59913 10.7246 5.22691 10.7246 5.96025C10.7246 6.69358 10.4635 7.32136 9.94128 7.84358C9.41905 8.3658 8.79128 8.62691 8.05794 8.62691ZM8.05794 7.29358C8.42461 7.29358 8.7385 7.16302 8.99961 6.90191C9.26072 6.6408 9.39128 6.32691 9.39128 5.96025C9.39128 5.59358 9.26072 5.27969 8.99961 5.01858C8.7385 4.75747 8.42461 4.62691 8.05794 4.62691C7.69128 4.62691 7.37739 4.75747 7.11628 5.01858C6.85516 5.27969 6.72461 5.59358 6.72461 5.96025C6.72461 6.32691 6.85516 6.6408 7.11628 6.90191C7.37739 7.16302 7.69128 7.29358 8.05794 7.29358ZM15.4579 16.2936L13.3246 14.1602C13.0913 14.2936 12.8413 14.4047 12.5746 14.4936C12.3079 14.5825 12.0246 14.6269 11.7246 14.6269C10.8913 14.6269 10.1829 14.3352 9.59961 13.7519C9.01628 13.1686 8.72461 12.4602 8.72461 11.6269C8.72461 10.7936 9.01628 10.0852 9.59961 9.50191C10.1829 8.91858 10.8913 8.62691 11.7246 8.62691C12.5579 8.62691 13.2663 8.91858 13.8496 9.50191C14.4329 10.0852 14.7246 10.7936 14.7246 11.6269C14.7246 11.9269 14.6802 12.2102 14.5913 12.4769C14.5024 12.7436 14.3913 12.9936 14.2579 13.2269L16.3913 15.3602L15.4579 16.2936ZM11.7246 13.2936C12.1913 13.2936 12.5857 13.1325 12.9079 12.8102C13.2302 12.488 13.3913 12.0936 13.3913 11.6269C13.3913 11.1602 13.2302 10.7658 12.9079 10.4436C12.5857 10.1214 12.1913 9.96025 11.7246 9.96025C11.2579 9.96025 10.8635 10.1214 10.5413 10.4436C10.2191 10.7658 10.0579 11.1602 10.0579 11.6269C10.0579 12.0936 10.2191 12.488 10.5413 12.8102C10.8635 13.1325 11.2579 13.2936 11.7246 13.2936ZM2.72461 13.9602V12.1102C2.72461 11.7325 2.81905 11.3825 3.00794 11.0602C3.19683 10.738 3.45794 10.4936 3.79128 10.3269C4.35794 10.038 4.99683 9.79358 5.70794 9.59358C6.41905 9.39358 7.20794 9.29358 8.07461 9.29358C7.94128 9.49358 7.82739 9.70747 7.73294 9.93525C7.6385 10.163 7.5635 10.3991 7.50794 10.6436C6.84128 10.6991 6.24683 10.813 5.72461 10.9852C5.20239 11.1575 4.7635 11.338 4.40794 11.5269C4.29683 11.5825 4.21072 11.663 4.14961 11.7686C4.0885 11.8741 4.05794 11.988 4.05794 12.1102V12.6269H7.50794C7.5635 12.8714 7.6385 13.1047 7.73294 13.3269C7.82739 13.5491 7.94128 13.7602 8.07461 13.9602H2.72461Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
}

export default UserSearchIcon
